<template>
	<div id="sign-form">
		<!-- <b-alert
      :show="dismissCountDown"
      dismissible
      variant="danger"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
      >{{ err }}</b-alert
    > -->
		<div class="appView">
			<div class="gatekeeperView logIn">
				<div class="gatekeeperContentView">
					<a :href="baseUrl"><div class="logo"></div></a>

					<div class="gatekeeperForm">
						<div class="formHeader">
							<div class="title">Welcome back!</div>
							<div class="separator"></div>
						</div>

						<div class="formContent tableView">
							<div class="tableSection sectionCredentials">
								<div class="block inputCell email">
									<div class="title">Email</div>
									<div class="input placeholder">
										<input
											v-model="email"
											type="email"
											class="form-control"
											@keyup="resetErrors()"
											placeholder="name@domain.com"
											v-on:keyup.enter="signinUser"
											@focus="resetErrors"
										/>
									</div>
								</div>

								<div class="block inputCell password">
									<div class="title">Password</div>
									<div class="input placeholder">
										<input
											v-model="password"
											type="password"
											class="form-control"
											@keyup="resetErrors()"
											placeholder="••••••••••••••••"
											v-on:keyup.enter="signinUser"
											@focus="resetErrors"
										/>
									</div>
								</div>

								<a href="/forgot" class="footer forgotPassword"
									>Forgot Password?</a
								>
							</div>

							<div
								class="button buttonLarge"
								:class="[!email || !password ? 'buttonDisabled' : 'buttonTint']"
								v-show="isActive"
								@click="signinUser"
							>
								<div
									class="title"
									data-style="slide-left"
									:class="isSuccessLoggedIn ? 'click-event-disable' : ''"
								>
									<SpinnerLoader
										v-if="isLoading"
										:size="30"
										:color="'#ffffff'"
									/>
									<span v-if="!isLoading && !isSuccessLoggedIn">Log in</span>
									<span v-if="isSuccessLoggedIn">Logged in</span>
								</div>
							</div>
							<div class="button errorButton" v-show="isError">
								<div class="title" data-style="slide-left">
									Couldn't Log in
								</div>
							</div>
							<span v-if="err" class="loginError">{{ err }}</span>
						</div>
					</div>

					<div class="additionalActions">
						<div
							class="button buttonLarge buttonActionTranslucent buttonLogin"
							@click="goToSignUp()"
						>
							<div class="title">
								Don't have an account yet? Sign Up
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Auth from "@aws-amplify/auth";
import { AmplifyEventBus } from "aws-amplify-vue";
import { SpinnerLoader } from "vue-spinners-css";
import {
	setToken,
	setUserId,
	setUserEmail,
	setFirstName,
	setLastName
} from "../../utils/auth";

export default {
	name: "Signin",
	data() {
		return {
			baseUrl: window.location.origin,
			signedIn: false,
			email: this.$route.query.email,
			password: "",
			isLoading: false,
			fullPage: false,
			dismissSecs: 5,
			dismissCountDown: 0,
			err: "",
			isError: false,
			isActive: true,
			isSuccessLoggedIn: false
		};
	},
	components: {
		SpinnerLoader
	},
	mounted() {
		const signInInput = document.querySelector("#sign-form .form-control");
		signInInput.focus();
	},
	methods: {
		resetErrors() {
			this.err = "";
			this.isActive = true;
			this.isSuccessLoggedIn = this.isLoading = this.isError = false;
		},
		goToSignUp() {
			this.$router.push({ name: "signup" });
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		onCancel() {
			console.log("User cancelled the loader.");
		},
		async signinUser() {
			try {
				this.isLoading = true;
				const user = await Auth.signIn(this.email, this.password);
				this.isSuccessLoggedIn = true;
				setUserId(user.username);
				setUserEmail(user.attributes.email);
				setFirstName(user.attributes.name);
				setLastName(user.attributes.family_name);
				Auth.currentSession();
				setToken(data.idToken.jwtToken);
			} catch (error) {
				this.isError = true;
				this.err = error.message;
				this.dismissCountDown = this.dismissSecs;
				return error;
			} finally {
				this.isLoading = false;
				this.isActive = false;
				this.$router.push({ name: "expenses" });
			}
		},
		async beforeCreate() {
			try {
				await Auth.currentAuthenticatedUser();
				this.signedIn = true;
			} catch (err) {
				this.signedIn = false;
			}
			AmplifyEventBus.$on("authState", info => {
				if (info === "signedIn") {
					if ((this.signedIn = true)) {
						this.$router.push({ name: "expenses" });
					}
				} else {
					this.signedIn = false;
				}
			});
		}
	}
};
</script>
